<template>
  <div class="chat-group-side">
    <!-- 移动端返回按钮 -->
    <div class="mobile-header">
      <span class="back-btn el-icon-arrow-left" @click="$emit('close')"></span>
      <span class="header-title">群聊信息</span>
    </div>
    <div v-show="!group.quit" class="setting-section member-section">
      <div class="section-title">群成员</div>
      <div class="member-content">
        <div class="search">
          <el-input placeholder="搜索群成员" v-model="searchText" size="small">
            <i class="el-icon-search el-input__icon" slot="prefix"> </i>
          </el-input>
        </div>
        <el-scrollbar ref="scrollbar" :style="'height: ' + scrollHeight + 'px'">
          <div class="member-list">
            <div class="member-tools" v-if="isOwner">
              <div class="tool-btn" title="邀请好友进群聊" @click="onInvite()">
                <i class="el-icon-plus"></i>
              </div>
              <div class="tool-text">邀请</div>
              <add-group-member ref="addGroupMember" :groupId="group.id" :members="groupMembers"
                @reload="$emit('reload')"></add-group-member>
            </div>
            <div class="member-tools" v-if="isOwner">
              <div class="tool-btn" title="选择成员移出群聊" @click="onRemove()">
                <i class="el-icon-minus"></i>
              </div>
              <div class="tool-text">移除</div>
              <group-member-selector ref="removeSelector" title="选择成员进行移除" :group="group"
                @complete="onRemoveComplete"></group-member-selector>
            </div>
            <div v-if="(groupMembers || []).length === 0" class="empty-members">
              <p>暂无群成员</p>
            </div>
            <div v-for="(member, idx) in showMembers" :key="member.id || idx">
              <group-member v-if="idx < showMaxIdx" class="group-side-member" :member="member"></group-member>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="form-container" v-if="!group.quit">
      <!-- 群聊信息 -->
      <div class="setting-section">
        <div class="section-title">群聊信息</div>

        <div class="setting-item" @click="isOwner ? openEditDialog('name') : null" :class="{ 'readonly': !isOwner }">
          <div class="setting-label">群名称</div>
          <div class="setting-value">{{ group.name }}</div>
          <div class="setting-arrow" v-if="isOwner">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="setting-item" @click="isOwner ? openEditDialog('notice') : null" :class="{ 'readonly': !isOwner }">
          <div class="setting-label">群公告</div>
          <div class="setting-value notice-value">{{ group.notice || '群主未设置群公告' }}</div>
          <div class="setting-arrow" v-if="isOwner">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="setting-item" @click="showQrCode">
          <div class="setting-label">群二维码</div>
          <div class="setting-value">功能待开发</div>
          <div class="setting-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <!-- 个性化设置 -->
      <div class="setting-section">
        <div class="section-title">个性化设置，仅对自己生效</div>

        <div class="setting-item" @click="openEditDialog('nickname')">
          <div class="setting-label">我在本群的昵称</div>
          <div class="setting-value">{{ group.remarkNickName || '未设置' }}</div>
          <div class="setting-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="setting-item" @click="openEditDialog('remark')">
          <div class="setting-label">群备注</div>
          <div class="setting-value">{{ group.remarkGroupName || '未设置' }}</div>
          <div class="setting-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="setting-item">
          <div class="setting-label">置顶会话</div>
          <div class="setting-value">
            <el-switch v-model="group.isTop" @change="onToggleTop"></el-switch>
          </div>
        </div>

        <div class="setting-item">
          <div class="setting-label">消息免打扰</div>
          <div class="setting-value">
            <el-switch v-model="group.isDnd" @change="onToggleDnd"></el-switch>
          </div>
        </div>
      </div>

      <!-- 机器人管理 -->
      <div class="setting-section">
        <div class="section-title">机器人管理</div>
        <div v-if="groupRobots.length === 0" class="setting-item readonly">
          <div class="setting-label">暂无机器人</div>
        </div>
        <div v-for="robot in groupRobots" :key="robot.id" class="robot-manage-item">
          <div class="robot-info-row">
            <div class="robot-avatar-small">
              <img v-if="robot.avatar" :src="robot.avatar" class="avatar">
              <i v-else class="el-icon-robot avatar-placeholder"></i>
            </div>
            <div class="robot-name-small">{{ robot.name }}</div>
          </div>
          <div class="robot-switches">
            <div class="switch-item">
              <span class="switch-label">免打扰</span>
              <el-switch 
                v-model="robot.isDnd" 
                @change="(val) => onToggleRobotDnd(robot.id, val)"
                size="small">
              </el-switch>
            </div>
            <div class="switch-item">
              <span class="switch-label">屏蔽</span>
              <el-switch 
                v-model="robot.isBlocked" 
                @change="(val) => onToggleRobotBlocked(robot.id, val)"
                size="small">
              </el-switch>
            </div>
          </div>
        </div>
      </div>

      <!-- 群管理 -->
      <div class="setting-section" v-if="isOwner">
        <div class="section-title">群管理设置，仅群主可设置</div>

        <div class="setting-item">
          <div class="setting-label">全员禁言</div>
          <div class="setting-value">
            <el-switch v-model="group.isMuted" @change="handleMuteChange"></el-switch>
          </div>
        </div>

        <div class="setting-item">
          <div class="setting-label">禁止私聊</div>
          <div class="setting-value">
            <el-switch v-model="group.isForbidPrivateChat" @change="handleForbidPrivateChatChange"></el-switch>
          </div>
        </div>

        <div class="setting-item" @click="onManageRobot">
          <div class="setting-label">机器人</div>
          <div class="setting-value">
            <span class="robot-info">
              <img src="https://img.icons8.com/color/20/000000/robot.png" class="robot-icon">
              <span>{{ robots.length }}</span>
            </span>
          </div>
          <div class="setting-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <div class="action-btn quit-btn" @click="onQuit">退出群聊</div>
        <div class="action-btn dissolve-btn" v-if="isOwner" @click="onDissolve">解散该群</div>
      </div>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog :title="editDialogTitle" :visible.sync="editDialogVisible" width="400px" class="wechat-dialog">
      <el-form :model="editForm" class="wechat-form">
        <el-form-item v-if="editType === 'notice'" label="群公告">
          <el-input type="textarea" v-model="editForm.value" maxlength="1024" :rows="4" class="wechat-input"></el-input>
        </el-form-item>
        <el-form-item v-else :label="editDialogTitle">
          <el-input v-model="editForm.value" maxlength="20" class="wechat-input"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer wechat-dialog-footer">
        <el-button class="wechat-btn cancel-btn" @click="editDialogVisible = false">取消</el-button>
        <el-button class="wechat-btn save-btn" @click="onSaveEdit">保存</el-button>
      </div>
    </el-dialog>

    <!-- 算数确认对话框 -->
    <el-dialog :title="confirmDialogTitle" :visible.sync="confirmDialogVisible" width="400px" :close-on-click-modal="false" class="wechat-dialog">
      <div v-if="confirmType === 'dissolve'" class="confirm-content">
        <p class="warning-text">解散群聊后，群里的所有消息将被清空，此操作不可撤销！</p>
        <div class="math-verify">
          <p>请输入以下算术题的答案，确认您的操作：</p>
          <div class="math-question">{{ mathQuestion }}</div>
          <el-input v-model="mathAnswer" placeholder="请输入答案" type="number" style="margin-top: 10px;" class="wechat-input"></el-input>
        </div>
      </div>
      <div v-else-if="confirmType === 'quit'" class="confirm-content">
        <p class="warning-text">退出群聊后将不再接受群里的消息，确认退出吗？</p>
        <div class="math-verify">
          <p>请输入以下算术题的答案，确认您的操作：</p>
          <div class="math-question">{{ mathQuestion }}</div>
          <el-input v-model="mathAnswer" placeholder="请输入答案" type="number" style="margin-top: 10px;" class="wechat-input"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer wechat-dialog-footer">
        <el-button class="wechat-btn cancel-btn" @click="confirmDialogVisible = false">取消</el-button>
        <el-button class="wechat-btn danger-btn" @click="confirmAction" :loading="confirmLoading">确认</el-button>
      </div>
    </el-dialog>

    <!-- 机器人管理对话框 -->
    <el-dialog title="机器人管理" :visible.sync="robotManageDialogVisible" width="500px">
      <div class="robot-manage">
        <el-scrollbar class="robot-list">
          <div v-for="robot in robots" :key="robot.id" class="robot-item" @click="editRobot(robot)">
            <div class="robot-avatar">
              <img v-if="robot.avatar" :src="robot.avatar" class="avatar">
              <i v-else class="el-icon-robot avatar-placeholder"></i>
            </div>
            <div class="robot-info">
              <div class="robot-name">{{ robot.name }}</div>
              <div class="robot-desc">由群主添加</div>
            </div>
            <div class="robot-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          
          <!-- 添加机器人 -->
          <div class="add-robot-item" @click="onAddRobot">
            <div class="add-icon">
              <i class="el-icon-plus"></i>
            </div>
            <div class="add-text">添加机器人</div>
            <div class="add-desc">多款丰富的精选机器人</div>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>

    <!-- 机器人编辑对话框 -->
    <el-dialog title="设置" :visible.sync="robotDialogVisible" width="500px">
      <div class="robot-setting">
        <div class="robot-avatar-section">
          <file-upload class="avatar-uploader" :action="robotAvatarAction" :showLoading="true"
            :maxSize="maxSize" @success="onRobotAvatarUploadSuccess" :uploadParams="robotAvatarParams"
            :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
            <img v-if="currentRobot.avatar" :src="currentRobot.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </file-upload>
        </div>

        <el-form :model="currentRobot" label-width="100px" size="small">
          <el-form-item label="机器人名字">
            <el-input v-model="currentRobot.name" maxlength="20"></el-input>
          </el-form-item>

          <el-form-item label="接收群组">
            <el-input v-model="group.name" readonly></el-input>
          </el-form-item>

          <el-form-item label="消息推送">
            <el-select v-model="currentRobot.isEnabled" style="width: 100%">
              <el-option label="开启" :value="true"></el-option>
              <el-option label="关闭" :value="false"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Webhook">
            <div class="webhook-container">
              <el-input v-model="fullWebhookUrl" readonly style="flex: 1"></el-input>
              <el-button type="warning" size="small" @click="resetWebhookUrl">重置</el-button>
              <el-button type="primary" size="small" @click="copyFullWebhookUrl">复制</el-button>
            </div>
            <div class="warning-text">*请保管好 Webhook 地址，不要公布在外部网站上，泄露有安全风险</div>
          </el-form-item>

          <el-form-item label="密钥">
            <div class="webhook-container">
              <el-input v-model="currentRobot.secret" readonly style="flex: 1"></el-input>
              <el-button type="primary" size="small" @click="copySecret(currentRobot.secret)">复制</el-button>
            </div>
          </el-form-item>
        </el-form>

        <div class="dialog-footer">
          <el-button type="danger" @click="onDeleteRobot">删除</el-button>
          <el-button @click="robotDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveRobot">完成</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddGroupMember from '../group/AddGroupMember.vue';
import GroupMember from '../group/GroupMember.vue';
import GroupMemberSelector from '../group/GroupMemberSelector.vue';
import FileUpload from '../common/FileUpload';

export default {
  name: "chatGroupSide",
  components: {
    AddGroupMember,
    GroupMember,
    GroupMemberSelector,
    FileUpload
  },
  data() {
    return {
      searchText: "",
      showMaxIdx: 50,
      editDialogVisible: false,
      editType: '',
      editDialogTitle: '',
      editForm: {
        value: ''
      },
      confirmDialogVisible: false,
      confirmDialogTitle: '',
      confirmType: '',
      confirmLoading: false,
      mathQuestion: '',
      mathAnswer: '',
      mathResult: 0,
      // 机器人相关
      robots: [],
      robotManageDialogVisible: false,
      robotDialogVisible: false,
      currentRobot: {},
      maxSize: 5 * 1024 * 1024,
      // 群机器人列表（用于管理）
      groupRobots: []
    }
  },
  props: {
    group: {
      type: Object
    },
    groupMembers: {
      type: Array
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onInvite() {
      this.$refs.addGroupMember.open()
    },
    onRemove() {
      let hideIds = [this.group.ownerId];
      this.$refs.removeSelector.open(50, [], [], hideIds);
    },
    onRemoveComplete(members) {
      let userIds = members.map(m => m.userId);
      let data = {
        groupId: this.group.id,
        userIds: userIds
      }
      this.$http({
        url: "/group/members/remove",
        method: 'delete',
        data: data
      }).then(() => {
        this.$emit('reload');
        this.$message.success(`您移除了${userIds.length}位成员`);
      })
    },
    loadGroupMembers() {
      this.$http({
        url: `/group/members/${this.group.id}`,
        method: "get"
      }).then((members) => {
        this.groupMembers = members;
      })
    },
    openEditDialog(type) {
      this.editType = type;
      switch(type) {
        case 'name':
          this.editDialogTitle = '群名称';
          this.editForm.value = this.group.name || '';
          break;
        case 'nickname':
          this.editDialogTitle = '我在本群的昵称';
          this.editForm.value = this.group.remarkNickName || '';
          break;
        case 'remark':
          this.editDialogTitle = '群备注';
          this.editForm.value = this.group.remarkGroupName || '';
          break;
        case 'notice':
          this.editDialogTitle = '群公告';
          this.editForm.value = this.group.notice || '';
          break;
      }
      this.editDialogVisible = true;
    },
    onSaveEdit() {
      let data = { ...this.group };
      switch(this.editType) {
        case 'name':
          data.name = this.editForm.value;
          break;
        case 'nickname':
          data.remarkNickName = this.editForm.value;
          break;
        case 'remark':
          data.remarkGroupName = this.editForm.value;
          break;
        case 'notice':
          data.notice = this.editForm.value;
          break;
      }
      this.$http({
        url: "/group/modify",
        method: "put",
        data: data
      }).then((group) => {
        this.editDialogVisible = false;
        this.groupStore.updateGroup(group);
        this.$emit('reload');
        this.$message.success("修改成功");
      })
    },
    showQrCode() {
      this.$message.info('群二维码功能开发中');
    },
    onQuit() {
      this.showMathConfirm('quit', '确认退出群聊');
    },
    onDissolve() {
      this.showMathConfirm('dissolve', '确认解散群聊');
    },
    showMathConfirm(type, title) {
      const num1 = Math.floor(Math.random() * 10) + 1;
      const num2 = Math.floor(Math.random() * 10) + 1;
      this.mathResult = num1 + num2;
      this.mathQuestion = `${num1} + ${num2} = ?`;
      this.mathAnswer = '';

      this.confirmType = type;
      this.confirmDialogTitle = title;
      this.confirmDialogVisible = true;
    },
    confirmAction() {
      if (parseInt(this.mathAnswer) !== this.mathResult) {
        this.$message.error('算术题答案错误，请重新输入');
        return;
      }

      this.confirmLoading = true;

      if (this.confirmType === 'quit') {
        this.$http({
          url: `/group/quit/${this.group.id}`,
          method: 'delete'
        }).then(() => {
          this.confirmDialogVisible = false;
          this.confirmLoading = false;
          this.groupStore.removeGroup(this.group.id);
          this.chatStore.removeGroupChat(this.group.id);
          this.$message.success('已退出群聊');
        }).catch(() => {
          this.confirmLoading = false;
          this.$message.error('退出群聊失败');
        });
      } else if (this.confirmType === 'dissolve') {
        this.$http({
          url: `/group/delete/${this.group.id}`,
          method: 'delete'
        }).then(() => {
          this.confirmDialogVisible = false;
          this.confirmLoading = false;
          this.groupStore.removeGroup(this.group.id);
          this.chatStore.removeGroupChat(this.group.id);
          this.$message.success('群聊已解散');
        }).catch(() => {
          this.confirmLoading = false;
          this.$message.error('解散群聊失败');
        });
      }
    },
    onToggleTop() {
      let chat = this.chatStore.findChatByGroup(this.group.id);
      if (chat) {
        let idx = this.chatStore.findChatIdx(chat);
        this.chatStore.moveTop(idx);
        this.$message.success(this.group.isTop ? '已置顶会话' : '已取消置顶');
      }
    },
    onToggleDnd() {
      this.$http({
        url: '/group/dnd',
        method: 'put',
        data: {
          groupId: this.group.id,
          isDnd: this.group.isDnd
        }
      }).then(() => {
        this.groupStore.setDnd(this.group.id, this.group.isDnd);
        this.chatStore.setDnd({ type: 'GROUP', targetId: this.group.id }, this.group.isDnd);
        this.$message.success(this.group.isDnd ? '已开启消息免打扰' : '已关闭消息免打扰');
      }).catch(() => {
        this.group.isDnd = !this.group.isDnd;
        this.$message.error('操作失败');
      });
    },
    handleMuteChange(val) {
      this.$http({
        url: '/group/mute',
        method: 'put',
        data: {
          groupId: this.group.id,
          isMuted: val
        }
      }).then(() => {
        this.groupStore.setMute(this.group.id, val);
        this.$message.success(val ? '已开启全员禁言' : '已关闭全员禁言');
      }).catch(() => {
        this.group.isMuted = !val;
        this.$message.error('操作失败');
      });
    },
    handleForbidPrivateChatChange(val) {
      this.$http({
        url: '/group/forbid-private-chat',
        method: 'put',
        data: {
          groupId: this.group.id,
          isForbidPrivateChat: val
        }
      }).then(() => {
        this.groupStore.setForbidPrivateChat(this.group.id, val);
        this.$message.success(val ? '已禁止群成员私聊' : '已允许群成员私聊');
      }).catch(() => {
        this.group.isForbidPrivateChat = !val;
        this.$message.error('操作失败');
      });
    },
    loadRobots() {
      if (!this.group.id) return;
      this.$http({
        url: `/group/robot/list/${this.group.id}`,
        method: "get"
      }).then((robots) => {
        this.robots = robots;
      })
    },
    loadGroupRobots() {
      // 加载群机器人列表（用于管理界面）
      if (!this.group.id) return;
      
      // 并行请求机器人列表和免打扰设置
      Promise.all([
        this.$http({
          url: `/group/robot/list/${this.group.id}`,
          method: "get"
        }),
        this.$http({
          url: `/group/robot/dnd/list/${this.group.id}`,
          method: "get"
        })
      ]).then(([robots, dndSettings]) => {
        // 构建免打扰设置映射
        const dndMap = {};
        dndSettings.forEach(setting => {
          dndMap[setting.robotId] = {
            isDnd: setting.isDnd || false,
            isBlocked: setting.isBlocked || false
          };
        });
        
        // 为每个机器人添加isDnd和isBlocked属性
        this.groupRobots = robots.map(robot => ({
          ...robot,
          isDnd: dndMap[robot.id]?.isDnd || false,
          isBlocked: dndMap[robot.id]?.isBlocked || false
        }));
        
        // 更新groupStore中的设置
        dndSettings.forEach(setting => {
          this.groupStore.setRobotDnd(this.group.id, setting.robotId, setting.isDnd || false);
          this.groupStore.setRobotBlocked(this.group.id, setting.robotId, setting.isBlocked || false);
        });
      })
    },
    onToggleRobotDnd(robotId, isDnd) {
      // 切换机器人的免打扰状态
      // 找到对应的机器人对象
      const robot = this.groupRobots.find(r => r.id === robotId);
      if (!robot) return;
      
      // 保存旧状态，用于失败时恢复
      const oldDndStatus = robot.isDnd;
      
      // 发送请求到后端
      this.$http({
        url: '/group/robot/dnd/set',
        method: 'post',
        data: {
          groupId: this.group.id,
          robotId: robotId,
          isDnd: isDnd
        }
      }).then(() => {
        // 请求成功，更新groupStore
        this.groupStore.setRobotDnd(this.group.id, robotId, isDnd);
        this.$message.success(isDnd ? '已开启消息免打扰' : '已关闭消息免打扰');
      }).catch(() => {
        // 请求失败，恢复旧状态
        robot.isDnd = oldDndStatus;
        this.$message.error('设置失败，请重试');
      });
    },
    onToggleRobotBlocked(robotId, isBlocked) {
      // 切换机器人的屏蔽状态
      // 找到对应的机器人对象
      const robot = this.groupRobots.find(r => r.id === robotId);
      if (!robot) return;
      
      // 保存旧状态，用于失败时恢复
      const oldBlockedStatus = robot.isBlocked;
      
      // 发送请求到后端
      this.$http({
        url: '/group/robot/dnd/set',
        method: 'post',
        data: {
          groupId: this.group.id,
          robotId: robotId,
          isBlocked: isBlocked
        }
      }).then(() => {
        // 请求成功，更新groupStore
        this.groupStore.setRobotBlocked(this.group.id, robotId, isBlocked);
        this.$message.success(isBlocked ? '已屏蔽机器人发言' : '已解除屏蔽机器人发言');
      }).catch(() => {
        // 请求失败，恢复旧状态
        robot.isBlocked = oldBlockedStatus;
        this.$message.error('设置失败，请重试');
      });
    },
    onManageRobot() {
      this.loadRobots();
      this.robotManageDialogVisible = true;
    },
    onAddRobot() {
      this.$prompt('请输入机器人名称', '添加机器人', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请输入机器人名称'
      }).then(o => {
        let data = {
          groupId: this.group.id,
          name: o.value
        }
        this.$http({
          url: `/group/robot/create`,
          method: 'post',
          data: data
        }).then((robot) => {
          this.robots.push(robot);
          this.currentRobot = JSON.parse(JSON.stringify(robot));
          this.robotManageDialogVisible = false;
          this.robotDialogVisible = true;
          this.$message.success('添加成功');
        })
      })
    },
    editRobot(robot) {
      this.currentRobot = JSON.parse(JSON.stringify(robot));
      this.robotManageDialogVisible = false;
      this.robotDialogVisible = true;
    },
    onRobotAvatarUploadSuccess(data) {
      this.currentRobot.avatar = data;
    },
    saveRobot() {
      let data = {
        id: this.currentRobot.id,
        name: this.currentRobot.name,
        avatar: this.currentRobot.avatar,
        isEnabled: this.currentRobot.isEnabled
      }
      this.$http({
        url: `/group/robot/update`,
        method: 'put',
        data: data
      }).then((updatedRobot) => {
        let index = this.robots.findIndex(r => r.id === updatedRobot.id);
        if (index !== -1) {
          this.robots[index] = updatedRobot;
        }
        this.$message.success('保存成功');
        this.robotDialogVisible = false;
      }).catch(() => {
        this.$message.error('保存失败');
      });
    },
    resetWebhookUrl() {
      this.$confirm('确定要重置Webhook地址吗？重置后旧地址将失效。', '确认重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: `/group/robot/reset-webhook/${this.currentRobot.id}`,
          method: 'put'
        }).then((updatedRobot) => {
          this.currentRobot.webhookUrl = updatedRobot.webhookUrl;
          this.currentRobot.secret = updatedRobot.secret;
          this.$message.success('Webhook地址已重置');
        }).catch(() => {
          this.$message.error('重置失败');
        });
      });
    },
    copyFullWebhookUrl() {
      navigator.clipboard.writeText(this.fullWebhookUrl).then(() => {
        this.$message.success('完整Webhook地址已复制');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    onDeleteRobot() {
      this.$confirm('确认删除该机器人吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: `/group/robot/delete/${this.currentRobot.id}`,
          method: 'delete'
        }).then(() => {
          this.robots = this.robots.filter(r => r.id !== this.currentRobot.id);
          this.$message.success('删除成功');
          this.robotDialogVisible = false;
        })
      })
    },
    copySecret(secret) {
      navigator.clipboard.writeText(secret).then(() => {
        this.$message.success('密钥已复制');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    updateGroupSetting(key, value) {
      let data = { ...this.group };
      data[key] = value;
      this.$http({
        url: "/group/modify",
        method: "put",
        data: data
      }).then((group) => {
        this.groupStore.updateGroup(group);
        this.$emit('reload');
      })
    },
    onScroll(e) {
      const scrollbar = e.target;
      if (scrollbar.scrollTop + scrollbar.clientHeight >= scrollbar.scrollHeight - 30) {
        if (this.showMaxIdx < this.showMembers.length) {
          this.showMaxIdx += 30;
        }
      }
    }
  },
  computed: {
    mine() {
      return this.userStore.userInfo;
    },
    ownerName() {
      let member = this.groupMembers.find((m) => m.userId == this.group.ownerId);
      return member && member.showNickName;
    },
    isOwner() {
      return this.group.ownerId == this.mine.id;
    },
    showMembers() {
      return (this.groupMembers || []).filter((m) => !m.quit && m.showNickName.includes(this.searchText))
    },
    scrollHeight() {
      return Math.min(400, 80 + this.showMembers.length / 5 * 80);
    },
    fullWebhookUrl() {
      return `https://xxdatapush.cn/box-api/group/robot/webhook/${this.currentRobot.webhookUrl}`;
    },
    robotAvatarAction() {
      return `/avatar/upload`;
    },
    robotAvatarParams() {
      return {
        type: 'robot',
        id: this.currentRobot.id
      };
    }
  },
  mounted() {
    let scrollWrap = this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap');
    scrollWrap.addEventListener('scroll', this.onScroll);
    // 加载群机器人列表
    this.loadGroupRobots();
  },
  watch: {
    'group.id': {
      handler(newVal) {
        if (newVal) {
          this.loadGroupRobots();
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-group-side {
  position: relative;
  background-color: #f5f5f5;

  .mobile-header {
    display: none;
    height: 44px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    border-bottom: var(--im-border);
    background-color: #fff;

    .back-btn {
      font-size: 20px;
      cursor: pointer;
      color: var(--im-text-color);
      margin-right: 10px;
      width: 20px;
      height: 20px;
      line-height: 20px;
    }

    .header-title {
      flex: 1;
      text-align: center;
      font-size: var(--im-font-size-large);
      font-weight: 600;
      color: var(--im-text-color);
    }
  }

  .setting-section {
    margin-bottom: 16px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

    .section-title {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 600;
      color: #999;
      margin: 0;
      padding: 12px 16px 8px;
      background-color: #fafafa;
      text-align: left;

      .section-title-text {
        flex: 1;
      }

      .owner-tag {
        font-size: 12px;
        color: #FF4D4F;
        background-color: #FFF1F0;
        border: 1px solid #FFCCC7;
        border-radius: 10px;
        padding: 1px 6px;
      }
    }

    .setting-item {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      border-bottom: var(--im-border);
      cursor: pointer;

      &.readonly {
        cursor: default;

        &:hover {
          background-color: transparent;
        }
      }

      &:last-child {
        border-bottom: none;
      }

      .setting-label {
        flex: 1;
        font-size: 14px;
        color: #333;
        text-align: left;
      }

      .setting-value {
        font-size: 14px;
        color: var(--im-text-color-light);
        margin-right: 8px;
        text-align: right;

        &.notice-value {
          max-height: 48px;
          line-height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .robot-info {
          display: flex;
          align-items: center;

          .robot-icon {
            margin-right: 4px;
          }
        }
      }

      .setting-arrow {
        color: var(--im-text-color-light);
        font-size: 14px;
      }

      &:hover {
        background-color: #f9f9f9;
      }
    }
  }

  .member-section {
    margin: 10px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

    .member-content {
      padding: 10px;
    }

    .search {
      margin-bottom: 10px;
      padding: 0;
    }

    .member-list {
      padding: 10px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 14px;
      text-align: center;

      .group-side-member {
        margin-left: 5px;
      }

      .member-tools {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 54px;
        margin-left: 5px;

        .tool-btn {
          width: 38px;
          height: 38px;
          line-height: 38px;
          border: var(--im-border);
          font-size: 14px;
          cursor: pointer;
          box-sizing: border-box;

          &:hover {
            border: #aaaaaa solid 1px;
          }
        }

        .tool-text {
          font-size: 12px;
          text-align: center;
          width: 100%;
          height: 30px;
          line-height: 30px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden
        }
      }

      .empty-members {
        text-align: center;
        padding: 40px 0;
        color: #999;
        font-size: 14px;
        width: 100%;
      }
    }
  }

  .form-container {
    padding: 10px;
    height: auto;

    .action-buttons {
      margin-top: 20px;

      .action-btn {
        display: block;
        width: 100%;
        height: 44px;
        line-height: 44px;
        text-align: center;
        border-radius: 8px;
        font-size: 14px;
        margin-bottom: 12px;
        cursor: pointer;
        font-weight: 600;

        &.quit-btn {
          color: #FF4D4F;
          border: 1px solid #FF4D4F;

          &:hover {
            background-color: #FFF1F0;
          }
        }

        &.dissolve-btn {
          color: #fff;
          background-color: #FF4D4F;
          border: 1px solid #FF4D4F;

          &:hover {
            background-color: #cf1322;
          }
        }
      }
    }
  }

  .confirm-content {
    .warning-text {
      color: #ff4d4f;
      font-weight: 600;
      margin-bottom: 16px;
      line-height: 1.5;
    }

    .math-verify {
      background-color: #f9f9f9;
      padding: 16px;
      border-radius: 8px;

      p {
        margin-bottom: 12px;
        color: #666;
      }

      .math-question {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
        text-align: center;
        padding: 12px;
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid #e8e8e8;
      }
    }
  }

  .robot-manage {
    .robot-list {
      max-height: 400px;

      .robot-item {
        display: flex;
        align-items: center;
        padding: 15px;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;

        &:hover {
          background-color: #f5f5f5;
        }

        .robot-avatar {
          margin-right: 15px;

          .avatar {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            display: block;
          }

          .avatar-placeholder {
            font-size: 48px;
            color: #c0c4cc;
          }
        }

        .robot-info {
          flex: 1;

          .robot-name {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 4px;
          }

          .robot-desc {
            font-size: 14px;
            color: #909399;
          }
        }

        .robot-arrow {
          color: #c0c4cc;
        }
      }

      .add-robot-item {
        display: flex;
        align-items: center;
        padding: 15px;
        cursor: pointer;

        &:hover {
          background-color: #f5f5f5;
        }

        .add-icon {
          width: 48px;
          height: 48px;
          border: 1px dashed #d9d9d9;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 15px;

          .el-icon-plus {
            font-size: 24px;
            color: #c0c4cc;
          }
        }

        .add-text {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 4px;
        }

        .add-desc {
          font-size: 14px;
          color: #909399;
        }
      }
    }
  }

  .robot-manage-item {
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    .robot-info-row {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .robot-avatar-small {
        width: 36px;
        height: 36px;
        margin-right: 10px;

        .avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: block;
        }

        .avatar-placeholder {
          font-size: 36px;
          color: #c0c4cc;
        }
      }

      .robot-name-small {
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
    }

    .robot-switches {
      display: flex;
      justify-content: flex-end;
      gap: 20px;

      .switch-item {
        display: flex;
        align-items: center;
        gap: 8px;

        .switch-label {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }

  .robot-setting {
    .robot-avatar-section {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;

      .avatar-uploader {
        --width: 80px;
        text-align: center;

        .avatar {
          width: var(--width);
          height: var(--width);
          border-radius: 50%;
          display: block;
        }

        .avatar-uploader-icon {
          font-size: 32px;
          color: #8c939d;
          width: var(--width);
          height: var(--width);
          line-height: var(--width);
          text-align: center;
        }
      }
    }

    .webhook-container {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .warning-text {
      color: #f56c6c;
      font-size: 12px;
      margin-top: 5px;
    }

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      gap: 10px;
    }
  }
}

.wechat-dialog {
  .el-dialog__header {
    padding: 20px 24px 12px;
    border-bottom: 1px solid #f0f0f0;
  }

  .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 0 24px 24px;
    border-top: none;
  }
}

.wechat-form {
  .el-form-item {
    margin-bottom: 20px;

    .el-form-item__label {
      font-size: 14px;
      color: #666;
      font-weight: normal;
    }
  }
}

.wechat-input {
  .el-input__inner {
    height: 44px;
    border-radius: 8px;
    border: 1px solid #e5e5e5;
    background: #f9f9f9;
    transition: all 0.3s ease;
    font-size: 15px;

    &:focus {
      border-color: #07c160;
      background: #fff;
      box-shadow: 0 0 0 2px rgba(7, 193, 96, 0.1);
    }

    &::placeholder {
      color: #c7c7c7;
      font-size: 15px;
    }
  }
}

.wechat-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.wechat-btn {
  padding: 0 20px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;

  &.cancel-btn {
    color: #666;
    border: 1px solid #e5e5e5;
    background: #fff;

    &:hover {
      border-color: #07c160;
      color: #07c160;
    }
  }

  &.save-btn {
    color: #fff;
    border: 1px solid #07c160;
    background: #07c160;

    &:hover {
      background: #06b055;
      border-color: #06b055;
    }
  }

  &.danger-btn {
    color: #fff;
    border: 1px solid #ff4d4f;
    background: #ff4d4f;

    &:hover {
      background: #cf1322;
      border-color: #cf1322;
    }
  }
}
</style>